/**
 * Turns a `LoadFailure` into what the player reads (DATA-047).
 *
 * `DATA-047` forbids reporting a level, or a game's index, as unloadable
 * without saying whether the cause was the network or the data -- the two
 * lead to different advice, and "could not load" leads to none. One function
 * because `LevelSelect` (loading a game's index) and `Play` (loading a game
 * module, then a level) hit the same four causes and must not describe them
 * differently by accident.
 */
import type { LoadCause, LoadFailure } from '@platform/levels';

const MESSAGES: Record<LoadCause, string> = {
  network: 'A network problem stopped this from loading. Check your connection and try again.',
  missing: 'This could not be found. It may have been removed in a newer version of the app.',
  data: 'This could not be read. The data looks damaged.',
  'app-outdated': 'This was made for a newer version of Puzzle Gate. Reload to update.',
};

export function loadFailureMessage(failure: LoadFailure): string {
  return MESSAGES[failure.cause];
}
